export default class StringUtils {
  // https://stackoverflow.com/a/55292366/5536342
  static trimAny = (target: string, remove: string): string => {
    let start = 0
    let end = target.length
    const len = remove.length

    while (start < end && StringUtils.hasSubstringAt(target, remove, start)) {
      start += len
    }
    while (end > start && StringUtils.hasSubstringAt(target, remove, end - start)) {
      end -= len
    }

    return start > 0 || end < target.length ? target.substring(start, end) : target
  }

  // is supposed to be faster than indexOf
  private static hasSubstringAt = (str: string, subStr: string, pos: number): boolean => {
    const len = subStr.length
    let idx = 0
    const max = str.length
    for (; idx < len; idx++) {
      if (pos + idx >= max || str[pos + idx] != subStr[idx]) {
        break
      }
    }
    return idx === len
  }

  // Filters out html tags and plreaces newlines with spaces
  static filterTags(text: string): string {
    if (!text) return text

    // Replace </p> with space to seperate lines from each other
    // Remove any '<>' enclosed tags
    text = text.replace(/<\/p>/g, ' ').replace(/<(.*?)>/g, '')

    // Replace HTML escape codes with real characters; Angular will automatically sanitize this input
    return text.replace(/&gt;/g, '>').replace(/&lt;/g, '<').replace(/&amp;/g, '&')
  }

  static currencyStringToLong(value: string): number {
    if (!value) {
      return null
    }
    const sig = value.startsWith('-') ? -1 : 1
    const valueSplit = value
      .replace('.', '') // ignore tausendertrennzeichen
      .replace('-', '') // remove negative signum
      .split(',')
    let result: number
    if (valueSplit.length === 1) {
      result = parseInt(valueSplit[0], 10) * 100
    } else if (valueSplit.length === 2 && valueSplit[1].length <= 2) {
      result = parseInt(valueSplit[0], 10) * 100 + parseInt(valueSplit[1], 10) * (valueSplit[1].length === 2 ? 1 : 10)
    }
    return sig * result
  }

  static currencyRepresentation(value: number): string {
    if (value !== null && value !== undefined) {
      return `${Math.trunc(value / 100)},${String(Math.abs(value) % 100).padStart(2, '0')}`
    }
    return ''
  }
}
